import type { PlannedMeal } from '@/types/meal-plan'

export const MEAL_TYPE: PlannedMeal['meal_type'] = 'diner'

export const DAY_LABELS = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag'] as const

export interface DayPlan {
  date: Date
  dateKey: string
  label: string
  meals: PlannedMeal[]
  isToday: boolean
}

export const formatDateForApi = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const formatDateForDisplay = (value: string) =>
  new Date(value).toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'short',
  })

export const formatDutchDate = (date: Date, options: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('nl-NL', options).format(date)

export const isRecipeMatch = (query: string, title: string, ingredients: string[], tags: string[]) => {
  const trimmedQuery = query.trim().toLowerCase()
  if (!trimmedQuery) {
    return true
  }

  const haystack = [title, ...ingredients, ...tags].join(' ').toLowerCase()
  return haystack.includes(trimmedQuery)
}
